import { headerAuth } from "../standardAuthPatterns";
import logo from "./logo.svg";
import { defineProduct, productVariant } from "../types";

export const honeycomb = defineProduct({
  name: "Honeycomb",
  tagLine: "Observability for distributed systems",
  logo,
  tags: ["observability", "data"],
  variants: [
    productVariant({
      identifier: "honeycomb",
      authLabel: "Configuration API key",
      protocol: "http",
      defaultUrlPattern: () => "https://api\\.honeycomb\\.io/.*",
      auth: (app) =>
        headerAuth([{ name: "X-Honeycomb-Team", value: app.secret.apiKey }]),
      steps: [
        {
          title: "Create a configuration API key",
          items: [
            {
              kind: "markdown",
              content:
                "In Honeycomb, go to **Account → Team settings → API keys** and create a configuration key for the environment you want to access.\n\nGrant the permissions your workflows need (datasets, queries, boards, triggers, SLOs).",
            },
          ],
        },
        {
          title: "Paste your API key",
          items: [
            {
              kind: "input",
              label: "Configuration key",
              placeholder: "hcxlk_…",
              required: true,
              target: { kind: "secrets", field: "apiKey" },
              helperText: "Configuration key for your Honeycomb environment.",
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => "https://api.honeycomb.io/1/auth",
      },
    }),
    productVariant({
      identifier: "honeycombMcp",
      authLabel: "MCP (management API key)",
      protocol: "http",
      defaultUrlPattern: () => "https://mcp\\.honeycomb\\.io/.*",
      auth: (app) =>
        headerAuth([
          {
            name: "Authorization",
            value: `Bearer ${app.secret.keyId}:${app.secret.keySecret}`,
          },
        ]),
      steps: [
        {
          title: "Create a management API key",
          items: [
            {
              kind: "markdown",
              content:
                "In Honeycomb, go to **Account → Team settings → API keys** and create a management API key.\n\nGrant the **Model Context Protocol** and **Environments** scopes with read access (and write if you need `create_board`).",
            },
          ],
        },
        {
          title: "Enter your key ID and secret",
          items: [
            {
              kind: "input",
              label: "Key ID",
              placeholder: "hcxmk_…",
              required: true,
              target: { kind: "secrets", field: "keyId" },
            },
            {
              kind: "input",
              label: "Key secret",
              placeholder: "Paste your key secret",
              required: true,
              target: { kind: "secrets", field: "keySecret" },
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => ({
          url: "https://mcp.honeycomb.io/mcp",
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            jsonrpc: "2.0",
            id: 1,
            method: "tools/list",
          }),
        }),
      },
    }),
  ],
});
